<form
  *ngIf="form && config?.controls && config.controls.length > 0"
  [formGroup]="form"
  novalidate
>
  <ng-container
    *ngFor="let control of config.controls; let controlIndex = index"
  >
    <input
      *ngIf="control.controlType === inputTypes.HIDDEN"
      type="hidden"
      [formControlName]="control.name"
    />

    <ng-container *ngIf="control.controlType === inputTypes.DATE">
      <div class="mat-label">
        <mat-label>{{ control.label }}</mat-label
        ><span>&nbsp;</span><span>&#42;</span>
      </div>
      <app-expiry-date
        [formControlName]="control.name"
        [labels]="expiryDateLabels"
      ></app-expiry-date>
      <mat-error>
        <ng-container *ngIf="expiryDays > 0">{{
          labels.stellar.gffp.gffpLabels.errorMsgs.expirationDateError ||
            "Please enter valid date"
        }}</ng-container>
      </mat-error>
    </ng-container>

    <ng-template #selectTemplate>
      <mat-form-field>
        <mat-label>{{ control.label }}</mat-label>

        <input
          [id]="control.name"
          type="text"
          [attr.aria-label]="control.label"
          matInput
          [formControlName]="control.name!"
          [matAutocomplete]="autoRef"
        />
        <mat-icon class="arrow-icon" matSuffix>{{ countryArrowIcon }}</mat-icon>
        <mat-autocomplete
          [displayWith]="getSelectedOptionLabel.bind(this, control?.options)"
          (opened)="countryArrowIcon = 'keyboard_arrow_up'"
          (closed)="countryArrowIcon = 'keyboard_arrow_down'"
          (optionSelected)="onParentOptionChange(control, $event.option.value)"
          #autoRef="matAutocomplete"
        >
          <mat-option
            *ngFor="let option of control?.filteredOptions | async"
            [value]="option.label"
          >
            {{ option.label }}
          </mat-option>
        </mat-autocomplete>

        <mat-hint *ngIf="control?.hint">
          {{ control.hint }}
        </mat-hint>

        <mat-error>
          <ng-container *ngTemplateOutlet="errorFields"></ng-container>
        </mat-error>
      </mat-form-field>
    </ng-template>

    <ng-template
      let-parentOption="parentOption"
      let-control="control"
      #childSelectTemplate
    >
      <mat-form-field *ngIf="parentOption.options?.length! > 0">
        <mat-label>{{ parentOption.childLabel }}</mat-label>

        <input
          [id]="parentOption.childControlName!"
          type="text"
          [attr.aria-label]="parentOption.childLabel"
          matInput
          [formControlName]="parentOption.childControlName!"
          [matAutocomplete]="autoChildRef"
        />
        <mat-icon class="arrow-icon" matSuffix>{{ countryArrowIcon }}</mat-icon>
        <mat-autocomplete
          [displayWith]="
            getSelectedOptionLabel.bind(this, parentOption?.options)
          "
          (opened)="countryArrowIcon = 'keyboard_arrow_up'"
          (closed)="countryArrowIcon = 'keyboard_arrow_down'"
          #autoChildRef="matAutocomplete"
        >
          <mat-option
            *ngFor="let option of parentOption.filteredOptions | async"
            [value]="option.label"
          >
            {{ option.label }}
          </mat-option>
        </mat-autocomplete>

        <mat-hint *ngIf="control?.hint">
          {{ control.hint }}
        </mat-hint>

        <mat-error>
          <ng-container
            *ngIf="
              !form.get(parentOption.childControlName!)!.hasError('required') &&
              !form.get(parentOption.childControlName!)!.hasError('pattern')
            "
          >
            <ng-container
              *ngIf="form.get(parentOption.childControlName!)!.hasError('min')"
            >
              {{ getErrorMessage(parentOption.childControlName!, "min") }}
            </ng-container>
            <ng-container
              *ngIf="form.get(parentOption.childControlName!)!.hasError('max')"
            >
              {{ getErrorMessage(parentOption.childControlName!, "max") }}
            </ng-container>
          </ng-container>

          <ng-container
            *ngIf="
              form.get(parentOption.childControlName!)!.hasError('required')
            "
          >
            {{ getErrorMessage(parentOption.childControlName!, "required") }}
          </ng-container>

          <ng-container
            *ngIf="
              form.get(parentOption.childControlName!)!.hasError('pattern')
            "
          >
            {{ getErrorMessage(parentOption.childControlName!, "pattern") }}
          </ng-container>

          <ng-container
            *ngIf="
              form
                .get(parentOption.childControlName!)!
                .hasError('stateNotFoundError')
            "
          >
            {{ labels.stellar.stateNotFound }}
          </ng-container>
        </mat-error>
      </mat-form-field>
    </ng-template>

    <ng-container
      *ngIf="control.controlType === inputTypes.SELECT && control.name"
    >
      <ng-container
        [ngTemplateOutlet]="selectTemplate"
        [ngTemplateOutletContext]="control"
      ></ng-container>
      <ng-container
        *ngIf="
          getParentSelectedOption(control.name, controlIndex) as parentOption
        "
      >
        <ng-container
          [ngTemplateOutlet]="childSelectTemplate"
          [ngTemplateOutletContext]="{
            parentOption: parentOption,
            control: control
          }"
        ></ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="control.controlType === inputTypes.INPUT">
      <mat-form-field>
        <mat-label>
          {{ control.label }}
          <!-- <ng-container *ngIf="!isRequired(control.validators)">(Optional)</ng-container> -->
        </mat-label>

        <input
          matInput
          [placeholder]="control.placeholder!"
          [formControlName]="control.name"
          [type]="control.inputType!"
        />

        <mat-hint *ngIf="control?.hint">
          {{ control.hint }}
        </mat-hint>

        <mat-error>
          <ng-container *ngTemplateOutlet="errorFields"></ng-container>
        </mat-error>
      </mat-form-field>
    </ng-container>

    <ng-template #errorFields>
      <!-- min max can get messed up if pattern fails and numbers are in field -->
      <ng-container
        *ngIf="
          !form.get(control.name)!.hasError('required') &&
          !form.get(control.name)!.hasError('pattern')
        "
      >
        <ng-container *ngIf="form.get(control.name)!.hasError('min')">
          {{ getErrorMessage(control.name, "min") }}
        </ng-container>
        <ng-container *ngIf="form.get(control.name)!.hasError('max')">
          {{ getErrorMessage(control.name, "max") }}
        </ng-container>
      </ng-container>

      <ng-container *ngIf="form.get(control.name)!.hasError('required')">
        {{ getErrorMessage(control.name, "required") }}
      </ng-container>

      <ng-container *ngIf="form.get(control.name)!.hasError('pattern')">
        {{ getErrorMessage(control.name, "pattern") }}
      </ng-container>
      <ng-container *ngIf="form.get(control.name!)!.hasError('invalidOption')">
        {{ labels.stellar.optionNotFound }}
      </ng-container>
      <ng-container
        *ngIf="form.get(control.name!)!.hasError('countryNotFoundError')"
      >
        {{ labels.stellar.countryNotFound }}
      </ng-container>
      <ng-container
        *ngIf="
          form.get(control.name!)!.hasError('sender-primaryIdentification-id')
        "
      >
        {{ mapiFieldErrorMessages.primaryIdInputFieldMessage }}
      </ng-container>
    </ng-template>
  </ng-container>
</form>
